<button mat-button (click)="onClick()" [obButton]="buttonType" type="button">
	{{ openDialogButtonText }}
</button>
